import type { SidePanel } from '../types';

export const SessionsList: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./SessionsList.vue')),
};
